import React from "react";
import Logo from "./Logo";
import "./BrandHeader.css";

interface Props {
  size?: number;
}

// Centered brand header used at the top of public-facing pages
// (ConfirmShell-wrapped landing pages and the customer booking page).
// Owns the layout + spacing so individual pages don't repeat the wrapper.
export default function BrandHeader({ size = 28 }: Props) {
  return (
    <div className="brand-header">
      <Logo size={size} withWordmark />
    </div>
  );
}
